import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-ten',
  templateUrl: './home-page-ten.component.html',
  styleUrls: ['./home-page-ten.component.scss']
})
export class HomePageTenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
